import { useState } from 'react';
import Image from 'next/image';

import { Box, Button, Heading, Modal, Tag, Text } from '@zillow/constellation-10';

import { ApplicationSampleModal } from '@zg-rentals/applications-components';

import UserInfo from '../../../assets/user-info.svg';

import ApplicationsBenefitsContent from '../../PostingPath/ApplicationsFormField/ApplicationsBenefitsContent';

type Props = {
  onClose: () => void;
  isRoomForRent: boolean;
};

const ApplicationsInfoModal = ({ onClose, isRoomForRent }: Props) => {
  const [displaySampleModal, setDisplaySampleModal] = useState(false);

  return (
    <Modal
      header={
        <Heading level={1} textStyle="body-lg-bold">
          Zillow applications
        </Heading>
      }
      body={
        <>
          <Tag tone="purple" css={{ marginRight: '200', marginBottom: '400' }}>
            Free
          </Tag>

          <Heading level={2} textStyle="heading-sm">
            Receive Zillow applications for this listing?
          </Heading>

          <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '600' }}>
            <Box css={{ gridColumnStart: '1', gridColumnEnd: { base: 'span 12', xl: 'span 8' }, marginBottom: '400' }}>
              <ApplicationsBenefitsContent isIntroModal={false} isRoomForRent={isRoomForRent} />

              <Heading level={3} textStyle="heading-sm" css={{ marginBlock: '400' }}>
                Why renters love using Zillow applications
              </Heading>
              <Text>
                They can save time and money by paying a single application fee to apply to multiple properties for 30
                days.
              </Text>
            </Box>

            <Box
              css={{
                display: 'grid',
                gridColumnStart: { base: '1', xl: '9' },
                gridColumnEnd: { base: 'span 12', xl: 'span 4' },
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Image alt="" src={UserInfo} />
                <Button tone="brand" emphasis="filled" onClick={() => setDisplaySampleModal(true)}>
                  View sample
                </Button>
              </Box>
            </Box>
          </Box>

          {displaySampleModal && <ApplicationSampleModal onClose={() => setDisplaySampleModal(false)} />}
        </>
      }
      onOpenChange={(open) => !open && onClose()}
      open={true}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

export default ApplicationsInfoModal;
